<template>
  <v-container v-if="filter">
    <report
      v-if="!filter.resourceId"
      title="Resource Results"
      :filter="filter"
      :team="team"
      :manager="manager"
      :user="user"
      show-change-filter
      v-on:refreshData="refreshData"
      v-on:rowClick="rowClick"
      :headers="headers"
      :loading="loading"
      :items="items"
      v-on:change="change"
    >
      <v-card-text>
        <loading-spinner v-if="loading"> </loading-spinner>
        <template v-else>
          <v-row>
            <report-overall-card
              label="Training Resources Sent"
              :value="overview.sentInstancesCount | no_decimal"
            >
              <div class="caption lighttext--text">
                Times resources have been sent
              </div>
            </report-overall-card>
            <report-overall-card
              label="Members"
              :value="overview.overallUserRecords.finished | no_decimal"
            >
              <div class="caption lighttext--text">
                Times members read resource
              </div>
            </report-overall-card>
            <report-overall-card
              label="Participation"
              :value="$options.filters.no_decimal(completion) + '%'"
              :color="
                $coreScores.getColor($coreScores.reverseFormat(completion))
              "
            >
              <div class="caption lighttext--text">
                % of resources read by members
              </div>
            </report-overall-card>
          </v-row>
        </template>
      </v-card-text>
    </report>
    <template v-else>
      <loading-spinner v-if="loading"> </loading-spinner>
      <resource-report
        v-else
        :resource="resource"
        :filter="filter"
        v-on:back="$router.push({ path: getBaseLink() })"
      >
      </resource-report>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ReportOverallCard from "@/components/reporting/ReportOverallCard";
import ResourceReport from "@/components/reporting/ResourceReport";
import Report from "@/components/reporting/Report";
import reports from "@/helpers/mixins/reports";
export default {
  name: "ResourceReportOverview",
  props: {
    filter: { type: Object },
    team: { type: Object },
    manager: { type: Object },
    user: { type: Object }
  },
  components: {
    ReportOverallCard,
    ResourceReport,
    Report
  },
  mixins: [reports],
  data: () => ({
    loading: false,
    headers: [
      { text: "Sent On", value: "sentDate" },
      { text: "Resource", value: "title" },
      { text: "Participation", value: "userRecords.completion" },
      { text: "Recipients", value: "userRecords.sent" },
      { text: "", value: "actions" }
    ]
  }),
  watch: {},
  computed: {
    completion() {
      if (this.overview.overallUserRecords) {
        return this.overview.overallUserRecords.completion;
      }
      return 0;
    },
    ...mapGetters({
      overview: "reporting/overview",
      items: "reporting/sent_resources",
      resource: "resource/resource"
    })
  },
  created() {
    this.refreshData();
  },
  methods: {
    rowClick(item) {
      this.$router.push({
        path: `/reporting/training/overview/training/${item.resourceId}/sends/${item.id}`
      });
    },
    refreshData() {
      this.loading = true;
      let callArray = [];
      if (this.filter.resourceId) {
        callArray.push(
          this.$store.dispatch("resource/getResource", this.filter.resourceId)
        );
      } else {
        callArray.push(
          this.$store.dispatch("reporting/getResourcesReport", this.filter)
        );
      }
      Promise.all(callArray)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    change(override) {
      let link = this.getBaseLink();
      switch (override.type) {
        case this.$enums.coreCardIdTypes.MEMBER:
          link += `/members/${override.id}`;
          break;
        case this.$enums.coreCardIdTypes.MANAGER:
          link += `/teams/${override.id}`;
          break;
        case this.$enums.coreCardIdTypes.TEAM:
          link += `/departments/${override.id}`;
          break;
      }

      this.$router.push({ path: link });
    }
  }
};
</script>
